import { sqliteTable, text, integer } from "drizzle-orm/sqlite-core";

// ============================================================================
// crm_activities — กิจกรรม/บันทึกการติดต่อ
// ============================================================================
export const crmActivities = sqliteTable("crm_activities", {
  id: text("id").primaryKey(), // ULID
  companyId: text("company_id").notNull(),
  referenceType: text("reference_type", {
    enum: ["lead", "deal", "contact", "organization"],
  }),
  referenceId: text("reference_id"),
  type: text("type", {
    enum: ["call", "email", "meeting", "note", "task", "line_message"],
  }),
  title: text("title"),
  description: text("description"),
  dueDate: text("due_date"),
  isDone: integer("is_done").default(0),
  completedAt: text("completed_at"),
  assignedTo: text("assigned_to"),
  // Call-specific fields
  phoneNumber: text("phone_number"),
  callDirection: text("call_direction"), // "inbound" | "outbound"
  callOutcome: text("call_outcome"),     // "connected" | "no_answer" | "voicemail" | "declined" | "busy"
  callDuration: integer("call_duration"), // seconds
  createdBy: text("created_by"),
  createdAt: text("created_at").notNull(),
  updatedAt: text("updated_at").notNull(),
});

// Type exports
export type CrmActivity = typeof crmActivities.$inferSelect;
export type NewCrmActivity = typeof crmActivities.$inferInsert;
